export const INBOUND_RATES_CONTACT_EMAIL = "inboundrates@deliverr.com";
export const PREP_CONTACT_EMAIL = "prep@deliverr.com";
export const RESERVE_STORAGE_CONTACT_EMAIL = "reservestorage@deliverr.com";
